<template>
  <div class="col-12 col-lg-8 col-xl-9">
    <div class="steps__container">
      <div class="steps__bar">
        <div
          class="bar__element"
          :class="flag == 1 || flag == 2 || flag == 3 ? 'active' : ''"
        >
          <div class="bar__number">1</div>
          <div class="bar__description">Seleccionar taller</div>
        </div>

        <div
          class="bar__element"
          :class="flag == 2 || flag == 3 ? 'active' : ''"
        >
          <div class="bar__number">2</div>
          <div class="bar__description">Seleccionar servicio</div>
        </div>
        <div class="bar__element" :class="flag == 3 ? 'active' : ''">
          <div class="bar__number">3</div>
          <div class="bar__description">Seleccionar día</div>
        </div>
      </div>

      <form action="" class="steps__form" @submit.prevent="formController()">
        <first-step-services-form
          :brands="brands"
          :districts="districts"
          :specialties="specialties"
          :url_get_popup="url_get_popup"
          :url_validate_user="url_validate_user"
          :url_register="url_register"
          :url_get_vehicle_models="url_get_vehicle_models"
          :url_get_vehicle_versions="url_get_vehicle_versions"
          :url_vehicle_store="url_vehicle_store"
          :url_get_user_vehicles="url_get_user_vehicles"
          :urls="urls"
          v-if="flag == 1"
        ></first-step-services-form>

        <second-step-services-form
          :url_get_operations_by_brand="url_get_operations_by_brand"
          :url_get_operations_by_id="url_get_operations_by_id"
          :url_assets="url_assets"
          :urls="urls"
          v-if="flag == 2"
        ></second-step-services-form>

        <third-step-services-form v-if="flag == 3"></third-step-services-form>
      </form>
    </div>
  </div>

  <div class="col-12 col-lg-4 col-xl-3" v-if="!frontpage">
    <detail-step-services
      :url_get_price="url_get_price"
      :url_get_address="url_get_address"
      :url_profile="url_profile"
      :url_send_mail_for_parts="url_send_mail_for_parts"
    ></detail-step-services>
  </div>
</template>
<script>
import axios from 'axios'
import { inject, provide, reactive, ref, watch } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'

export default {
  emits: ['update:vehicles'],
  props: {
    frontpage: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    brands: {
      type: Array,
      default: () => [],
    },
    districts: {
      type: Array,
      default: () => [],
    },
    specialties: {
      type: Array,
      default: () => [],
    },
    order: {
      type: Object,
      default: () => {},
    },
    user_id: {
      type: [String, Number],
      default: null,
    },
    garages: {
      type: Array,
      default: () => [],
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
    dates: {
      type: Array,
      default: () => [],
    },
    hours: {
      type: Array,
      default: () => [],
    },
    garage_id: {
      type: [String, Number],
      default: null,
    },
    url_store: {
      type: String,
      default: '',
    },
    url_get_popup: {
      type: String,
      default: '',
    },
    url_get_operations_by_brand: {
      type: String,
      default: '',
    },
    url_get_price: {
      type: String,
      default: '',
    },
    url_get_address: {
      type: String,
      default: '',
    },
    url_validate_user: {
      type: String,
      default: '',
    },
    url_profile: {
      type: String,
      default: '',
    },
    url_send_mail_for_parts: {
      type: String,
      default: '',
    },
    url_get_operations_by_id: {
      type: String,
      default: '',
    },
    url_register: {
      type: String,
      default: '',
    },
    url_get_vehicle_models: {
      type: String,
      default: '',
    },
    url_get_vehicle_versions: {
      type: String,
      default: '',
    },
    url_vehicle_store: {
      type: String,
      default: '',
    },
    url_get_user_vehicles: {
      type: String,
      default: '',
    },
    url_assets: {
      type: String,
      default: '',
    },
    urls: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const loading = inject('loading')
    const userVehicles = ref(props.vehicles)

    const flag = ref(1)
    let order

    if (props.id !== '') {
      order = reactive(props.order)

      flag.value = 3
    } else {
      order = reactive({
        order_status_id: 1,
        client_id: props.user_id,
        garage_id: '',
        garage_name: '',
        garage_full_address: '',
        garage_opening_hours: '',
        garage_opening_hours_saturday: '',
        garage_opening_hours_sunday: '',
        garage_specialties: [],
        operation_flag: false,
        operation_id: '',
        operation_name: '',
        other_requirements_flag: false,
        other_requirements: '',
        vehicle_id: '',
        vehicle_plate: '',
        brand_id: '',
        brand_name: '',
        model_name: '',
        version_id: '',
        version_name: '',
        schedule_date: '',
        schedule_time: '',
        subtotal: '',
        igv: '',
        total: '',
        request_response: false,
        scheduled_appointment: false,
        parts_without_price: [],
        glp_conversion: false,
        gnv_conversion: false,
        body_work: false,
      })
    }

    if (props.garage_id !== '' && props.garage_id !== null) {
      order.garage_id = props.garage_id
      flag.value = 2
    }

    provide('garages', props.garages)
    provide('order', order)
    provide('flag', flag)
    provide('vehicles', userVehicles)
    provide('dates', props.dates)
    provide('hours', props.hours)
    provide('frontpage', props.frontpage)
    provide('user_id', props.user_id)

    watch(
      () => order.garage_id,
      (currentValue, oldValue) => {
        if (currentValue !== oldValue) {
          order.vehicle_id = ''
          order.vehicle_plate = ''
          order.brand_name = ''
          order.model_name = ''
          order.version_id = ''
          order.version_name = ''
          order.operation_id = ''
          order.operation_name = ''
          order.other_requirements = ''
          order.other_requirements_flag = false
          order.request_response = false
          order.scheduled_appointment = false
          order.glp_conversion = false
          order.gnv_conversion = false
          order.body_work = false
          order.operation_flag = false
        }
      }
    )

    watch(
      () => userVehicles,
      (currentValue, oldValue) => {
        emit('update:vehicles', currentValue)
      }
    )

    const formController = async () => {
      if (order.schedule_date === '') {
        const data = {
          type: 2,
          title: '¡Ups!',
          subtitle: 'Debe seleccionar un Día',
        }

        customAlert(data)

        return false
      }

      if (order.schedule_time === '') {
        const data = {
          type: 2,
          title: '¡Ups!',
          subtitle: 'Debe seleccionar una Hora',
        }

        customAlert(data)

        return false
      }

      flag.value = 3

      loading.value = true

      try {
        const { data } = await axios.request({
          url: props.url_store,
          method: 'POST',
          data: order,
        })

        // fbq("track", "Schedule");

        loading.value = false

        customAlert(data)
      } catch (error) {
        console.error(error)

        loading.value = false
      }
    }

    return {
      flag,
      userVehicles,
      formController,
    }
  },
}
</script>
<style lang=""></style>
